import { render } from "./CreateLiquidation5.vue?vue&type=template&id=063eca80"
import script from "./CreateLiquidation5.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation5.vue?vue&type=script&lang=js"

import "./CreateLiquidation5.vue?vue&type=style&index=0&id=063eca80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__